import React, { createContext, useContext, useReducer } from "react"

import { SET_INITIAL_STATE, ADD_PRICE } from "./actions"

const LOCAL_STORAGE_KEY = "unitPrices"

let DEFAULT_STATE = []

const PricesContext = createContext(DEFAULT_STATE)

const pricesReducer = (state, { type, payload }) => {
  let newState = [...state]

  switch (type) {
    case SET_INITIAL_STATE:
      newState = [...payload]
      break

    case ADD_PRICE:
      const currentIndex = newState.findIndex((el) => el.id === payload.id)
      // We might update the value immediately in the Leadoo bot.
      // --> So check for the existence and replace with the newest value if it differs from the previous one.
      if (newState[currentIndex]) {
        newState = newState.filter((el) => el.id !== payload.id)
      }
      newState.push({ ...payload })
      break

    default:
      throw new Error(`Unhandled action type: ${type}`)
  }

  if (type !== SET_INITIAL_STATE) {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(newState))
  }

  return newState
}

const PricesProvider = ({ children }) => {
  const [state, dispatch] = useReducer(pricesReducer, DEFAULT_STATE)
  const value = { state, dispatch }

  return (
    <PricesContext.Provider value={value}>{children}</PricesContext.Provider>
  )
}

const usePricesContext = () => {
  const context = useContext(PricesContext)

  return context
}

const getSavedState = (dispatch) => {
  const savedState = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY))

  if (savedState) {
    dispatch({
      type: SET_INITIAL_STATE,
      payload: JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)),
    })
  }
}

export { PricesProvider, usePricesContext, getSavedState }
